import { useTheme, Button as MuiButton, CircularProgress, SxProps } from '@mui/material';
import { ReactNode } from 'react';

type buttonType = 'button' | 'submit' | 'reset' | undefined;

interface ButtonProps {
  text?: string;
  color?: 'primary' | 'info';
  mode?: 'text' | 'contained' | 'outlined';
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  loading?: boolean;
  disabled?: boolean;
  type?: buttonType;
  onClick?: (e: any) => void;
  size?: 'small' | 'medium' | 'large';
  sx?: SxProps;
};

const Button = ({
  text,
  color = 'primary',
  mode = 'contained',
  size = 'medium',
  startIcon = null,
  loading,
  disabled,
  type,
  onClick,
  sx = {},
}: ButtonProps) => {
  const theme = useTheme();

  const baseStyles = {
    textTransform: 'none',
    display: 'flex',
    borderRadius: '10px',
  };

  const sizeStyles = {
    small: {
      height: '28px',
      padding: '4px 10px 4px 10px',
    },
    medium: {
      height: '32px',
      padding: '6px 16px 6px 16px',
    },
    large: {
      height: '36px',
      padding: '8px 22px 8px 22px',
    },
  };

  const modeStyles = {
    contained: {
      primary: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
    },
    outlined: {
      primary: {
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`
      },
    },
    text: {
      primary: {
        color: theme.palette.primary.main,
      },
    },
  } as const;

  const style = {
    ...baseStyles,
    ...modeStyles[mode][color],
    ...sizeStyles[size],
    ...sx,
  };

  return (
    <MuiButton
      type={type}
      onClick={onClick}
      disabled={disabled}
      variant={mode}
      disableElevation
      sx={style}
    >
      {loading && (
        <CircularProgress
          size="1rem"
          sx={{
            color: modeStyles[mode][color].color,
            marginRight: '8px'
          }}
        />
      )}
      {!loading && startIcon}
      {text}
    </MuiButton>
  );
};

export default Button;